export default "__VITE_ASSET__Wz0Ai14b__"